import { render, staticRenderFns } from "./SignUp.vue?vue&type=template&id=a47a26de&scoped=true&"
import script from "./SignUp.vue?vue&type=script&lang=js&"
export * from "./SignUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a47a26de",
  null
  
)

export default component.exports